<template>
  <div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <h3 class="text-center mb-3">
            <slot />
          </h3>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row text-center mt-3 p-1 py-md-1 px-md-5">
        <div
          class="col-12 col-lg-10 col-xl-8 align-self-center mx-auto text-center"
        >
          <carousel
            :scrollPerPage="true"
            :perPage="5"
            :perPageCustom="[
              [320, 1],
              [768, 3],
              [1024, 4]
            ]"
            :autoplay="true"
            :loop="true"
            easing="linear"
            :speed="300"
          >
            <slide class="m-auto">
              <div class="mb-3">
                <img
                  src="/assets/images/shipment.png"
                  style="width: 145px; height: 100px; object-fill: cover"
                />
                <p class="text-dark mt-2 mb-0 small">
                  355,000+ Kilograms of produce shipped We deliver, Locally,
                  within the region, and globally
                </p>
              </div>
            </slide>
            <slide class="m-auto">
              <div class="mb-5">
                <img
                  src="/assets/images/arrow.png"
                  style="width: 71px; height:63px; object-fill: cover"
                />
              </div>
            </slide>
            <slide class="m-auto">
              <div class="mb-3">
                <img
                  src="/assets/images/factory.jpg"
                  class="img-fluid"
                  style="width: 234px; height: 127px; object-fill: cover"
                />
                <p class="text-dark mt-2 mb-0 small">
                  We deliver to processors, Food businesses & FMCG’s Locally,
                  within the region, and globally
                </p>
              </div>
            </slide>
            <slide class="m-auto">
              <div class="mb-3">
                <img
                  src="/assets/images/green_home.png"
                  style="width: 89px; height: 124px; object-fill: cover"
                />
                <p class="text-dark mt-2 mb-0 small">
                  We deliver to homes and restaurants locally, within the
                  region, and globally.
                </p>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide
  }
};
</script>
